import Input, { InputProps } from '@repo/ui/input'

import { useFormField } from '../forms/form'

const ControlledInput: React.FC<
  InputProps & {
    onChange?: (value: string | null) => void
  }
> = (props) => {
  const { error } = useFormField()

  return (
    <Input
      {...props}
      value={props.value === null ? undefined : props.value}
      errorMessage={error ? String(error?.message) : undefined}
      onChange={(e) => props.onChange?.(e.target.value === '' ? null : e.target.value)}
    />
  )
}

export default ControlledInput
